/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeTriggerType = core.serialization.enum_(["manual", "automatic", "automatic_silent"]);
